// The stale check on open runs quietly (2026-10-29, docs/contact-view.md
// "Stale check on open"). Opening a contact whose pending suggestion is
// AI_AUTO_REGENERATE_STALE_MINUTES old asks the server for a refresh
// (?ifChanged=true). The panel shows no "Regenerating…" for it and the draft
// stays editable. What happens when it answers:
// - 'unchanged': the same suggestion came back (the server reused it) or none
//   at all. Nothing is applied and nothing is shown.
// - 'silent': a new suggestion, and the agent has not started work. It is
//   applied, with the "Updated with new information" line.
// - 'apply': a new suggestion over the agent's edits (the "A new suggestion
//   is ready" dialog asks, applyIfConfirmed()), or a Sales Hold phone call,
//   which regenerates on every open and so gets no line.
export const QUIET_UPDATED_TEXT = 'Updated with new information'

export function quietCheckOutcome({ updated, appliedId, dirty = false, forced = false } = {}) {
  if (!updated?.id || updated.id === appliedId) return 'unchanged'
  if (dirty || forced) return 'apply'
  return 'silent'
}

// The tooltip on each button that waits for the check (QuietCheckGate.jsx).
export const QUIET_CHECKING_TOOLTIP = 'Checking for updates…'
